<template >
    <section id="login">
      <main>
          <form v-if="!authenticated" id="login-form" class="" action="#" method="post" v-on:submit.prevent="logIn">
          <div class="card">
              <img class="img-border" src="../../static/img/logo.png" alt="KALEIDO | Shipping Board"/>
              <div class="field">
                <div style="margin: .2em 0;">
                  <label>{{$ml.get('user')}}</label>
                  <input class="" type="text" id="username" v-model="username" :placeholder="$ml.get('user')" autocomplete="username">
                </div>
              </div>
              <div class="field">
                <div style="margin: .2em 0;">
                  <label>{{$ml.get('pass')}}</label>
                  <input class="password" :type="showPass ? 'text' : 'password'" name="password" id="password"  v-model="password" :placeholder="$ml.get('pass')" autocomplete="current-password">
                  <i @click="showPass=!showPass" class="far fa-eye" :style="showPass?'':'opacity:.5'"/>
                </div>
              </div>
              <button type="submit" class="btn-login" name="login-button" form="login-form" value="login">
                ENTER
                <i v-if="login" style="padding: .1em" class="fa fa-spin fa-spinner"/>
              </button>
          </div>
        </form>
      </main>
    </section>
</template>

<script>
export default {
  name: 'login',
  created: function () {
    if (this.authenticated) {
      this.$router.push('/')
    }
  },
  props: ['authenticated'],
  data () {
    return {
      username: '',
      password: '',
      login: false,
      showPass: false
    }
  },
  methods: {
    logIn () {
      this.login = true
      this.$store.dispatch('auth/login', {
        username: this.username,
        password: this.password
      }).then(
        response => {
          let redirect = '/'
          if (this.$router.history.current.query.redirect) {
            redirect = this.$router.history.current.query.redirect
          }
          this.$router.push(redirect)
        }
      )
        .catch(error => {
          this.login = false
          throw error
        })
    }
  }
}
</script>

<style scoped lang="scss">
@import '../assets/scss/variables.scss';
section {
  margin: auto;
}
#login{
  height: 100%;
  color: $k-black;
  position: relative;
  text-transform: uppercase;
  font-family: "MuseoSans-900";
  text-align: center;
  border: none;
}
.card{
  padding: 2em;
  max-width: calc(22em + 1vw);
  background: white;
}
label {
  display: inline-block;
  background: $k-lime;
  color: black;
  padding: .75em;
  width: 40%;
  text-align: center;
  border: 1px solid  $k-lime;
  box-sizing: border-box;
}
input{
  display: inline-block;
  color: black;
  padding: .75em;
  text-align: center;
  font-size: 1em;
  width:60%;
  box-sizing: border-box;
  border: 2px solid $k-grey-dark;
}
.btn-login {
  margin-top:.5em;
  width: 100%;
  font-size: 1em;
  background: $k-lime;
  border:none;
  padding: 1em;
  font-family: MuseoSans-500;
  border-radius: .3em;
}
.password{
  padding-right: 30px;
}
.fa-eye {
  margin-left: -30px;
}
</style>



// WEBPACK FOOTER //
// src/pages/PageLogin.vue